import { FormControl, Grid, TextField, Typography } from '@mui/material'
import { CustomAutocomplete } from 'common'
import React from 'react'

export const ApprovalManagement = (props) => {
    const {formState, optionsAprobacionCheck, onSelectSearchChange} = props
    return (
        <>
            <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                Estado de aprobacion
            </Typography>
            <div className="border-bottom border-dark"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mt: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="aprobacion_check">Estado de aprobacion</label>
                        <CustomAutocomplete
                        customId="aprobacion_check"
                        customName="aprobacion_check"
                        customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'aprobacion_check', value: value.value }  })}
                        customValue={formState.aprobacion_check}
                        customPlaceholder='Seleccione una gestion'
                        customOptions={
                            optionsAprobacionCheck.map(({value, label }) => ({
                                value: value,
                                name: label
                            }))
                        }
                        customDisableClearable={true}
                        customDisabled={false}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="aprobacion_fecha">Fecha de aprobacion</label>
                        <TextField
                            id='aprobacion_fecha'
                            name='aprobacion_fecha'
                            value={ formState.aprobacion_fecha } 
                            // onChange={ onInputChange }
                            size='small'
                            placeholder='Fecha de aprobacion'
                            type='date'
                            variant='filled'
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                
            </Grid>
        </>
      )
}
